import React, { useEffect, useState } from "react";
import { api, inr } from "../../lib/api";

const STATUS = { paid: "text-emerald-400 bg-emerald-500/10", pending: "text-amber-400 bg-amber-500/10", failed: "text-red-400 bg-red-500/10", refunded: "text-content-muted bg-card-hover" };

export default function Orders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/student/orders").then((r) => setOrders(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <h1 className="font-heading text-2xl font-bold mb-6">Orders & Payments</h1>
      {orders.length === 0 ? <div className="card-surface p-8 text-center text-content-muted">No orders yet.</div> : (
        <div className="space-y-3">
          {orders.map((o) => (
            <div key={o.id} className="card-surface p-4 flex items-center justify-between" data-testid={`order-${o.id}`}>
              <div>
                <div className="text-sm font-medium">{o.product_name}</div>
                <div className="text-xs text-content-muted mt-0.5">{new Date(o.created_at).toLocaleDateString("en-IN")} • {o.coupon_code ? `Coupon ${o.coupon_code}` : "No coupon"}</div>
              </div>
              <div className="text-right">
                <div className="font-heading font-bold text-sm">{inr(o.total)}</div>
                <span className={`text-[11px] px-2 py-0.5 rounded-full capitalize ${STATUS[o.status] || "text-content-muted"}`}>{o.status}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
